import { render, staticRenderFns } from "./RepairRecordForm.vue?vue&type=template&id=2c3a5f0e&scoped=true&"
import script from "./RepairRecordForm.vue?vue&type=script&lang=js&"
export * from "./RepairRecordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3a5f0e",
  null
  
)

export default component.exports